const Data3 = ({ ad1, ad2, ad3, ad4, ad5, ad6, ad7, ad8 }) => {
  return (
    <div className="data3 ">
      <h1>Advisors</h1>
        <div className="row">
        <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad1}
              alt="one"
              width={200}
            />
          </div>
        <div className="col">
            <h3>Ms. Marie Ang</h3>
            <p>
              Marie Ang is the Founder & CEO of Solomon’s Guild specializing in
              coaching, mentoring, counselling and consulting with women,
              marriage and corporate leaders in transition. She also worked in
              the community and is very passionate about empowering women and to
              promote gender equality and integration. Marie serves in the
              People’s Association Women Integration Network Council to inspire
              more women towards community leadership and contribution. Over and
              above that Marie has served and is still serving on the advisory
              boards of several businesses in Australia, China and Hong Kong.As
              a certified John C. Maxwell and ICF coach, Marie also provide
              counselling services in building strong marriages and intrinsic
              values as a woman individually so as to add value to themselves,
              their families, their careers and the communities at large. Having
              worked with various MNCs and with over 30 years of corporate
              management experience, in various countries and in diverse
              industries such as education, banking, finance and aviation, Marie
              inspires others to live a life of significance. She is a mentor to
              the HKU MBA Professional Students, IEMP Irish Government and
              Chamber of Commerce programme as well as various communities’
              initiatives such as E2i, HK Guide Dogs Association, AOG, NTU, GGA,
              Honour Singapore. Author of ‘OMG! What’s The Matter With Me?”
              sharing her experiences in leadership, personality, conflict
              management and relationship. A sought-after speaker in various
              business, educational and professional fora, Marie was recognized
              and profiled in the Huffington post as a leader in spearheading
              leadership in women. Her curriculum to reach out to the various
              industries was endorsed by the China Provincial Mayor in the
              township of Shunde, Guangzhou to assist in leadership, cultural
              and people transformation.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad2}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Prof. Jasjit Singh</h3>
            <p>
              Jasjit Singh has been an INSEAD professor since 2004. His
              interests include Strategy, Inclusive Business, Sustainable
              Development, Innovation, Impact Investing and Impact Evaluation.
              He is particularly passionate about how market forces and business
              tools can be used as a force for good, and regularly teaches in
              INSEAD's MBA, EMBA and executive programmes on this topic. He also
              gives speeches, conducts workshops and advises enterprises,
              non-profits and investors on how to systematically think about
              their impact.
            </p>
          </div>
        </div>
        <div className="row">
        <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad3}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Dr. Allen Lai</h3>
            <p>
              Allen’s current role is the Senior Vice President of ACT Genomics
              based in Singapore. Allen has extensive experience across the full
              spectrum of healthcare industries. He holds concurrent
              appointments as President of the International Society of
              Pharmacoeconomics and Outcomes Research (ISPOR) Singapore Chapter
              and Advisor of Department of Health Promotion, Ministry of Health
              and Welfare (MOHW) in Taiwan. Prior to joining ACT Genomics, Allen
              was the principal consultant at IMS Health for Health Economics
              and Outcomes Research, Real World Evidence Solutions, spearheading
              the development of IMS Institute Asia, holding dual-roles within
              ESSEC Business School, as the Co-Director of the Masters of
              Science in Management of Health Industries and the Director of
              Institute of Health Economics and Management.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad4}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Dr. Alan Prem Kumar</h3>
            <p>
              Dr. Alan is a Principal Associate at Cancer Science Institute of
              Singapore, National University of Singapore and an Assistant
              Professor at Medical Science Cluster and Department of
              Pharmacology of Yong Loo Lin School of Medicine, NUS. He is
              Advisor to various pharmaceutical companies and an
              adjunct/visiting professor at various universities globally.
            </p>
          </div>
        </div>
        <div className="row">
        <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad5}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Ms. Marta Vlatchkova</h3>
            <p>
              With about 20 years of experience in Financial Planning and
              Analysis, Marta is currently working as the Director (FP&A) at
              Essilor, Singapore with Asia, Middle East, Russia and Africa under
              her supervision. She has worked and collaborated with various
              organisation in Europe, Middle East and Asia.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad6}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Mr. Nedir Boudriga</h3>
            <p>
              Nedir is the Director of Market Risk & Product Control at Julius
              Baer, Singapore with over 10 years of experience in Banking. He
              has an immense expertise in Trading, Structuring and Market Risks
              and Random Modelling.
            </p>
          </div>
        </div>
        <div className="row">
        <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad7}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Prof. Roger Lehman</h3>
            <p>
              Roger Lehman, a long time professor at INSEAD Business School,
              Singapore, specializes in entrepreneurship, leadership, life-long
              learning, leading change and innovation. He also serves as the
              Director of Executive Masters in Consulting and Coaching for
              Change program at INSEAD. In addition to academic teaching, he
              designs and teaches company-specific programs focussing on change
              management, leading innovation, personal and professional
              development and high-performance teams for his clients such as
              Deutsche Bank, HSBC, SAP, BP, Church of English Bishops and Credit
              Suisse.
            </p>
          </div>
          
        </div>
        <div className="row">
          <div className="col-auto  my-3">
            <img
              style={{ borderRadius: "50%" }}
              src={ad8}
              alt="one"
              width={200}
            />
          </div>
          <div className="col">
            <h3>Prof. Vishal Narayan</h3>
            <p>
              Vishal Narayan is currently working as an Associate Professor,
              Marketing at the NUS Business School. His research interests
              include emerging markets, network effects, social and
              collaboration networks. Prior to NUS, he was associated with
              Johnson School, Cornell University as an Assistant Professor in
              Marketing till 2013. He runs various research and educational
              programs in collaboration with multinational companies and
              academic institutions all around the world. He is the Editorial
              Board member of Marketing Science journal since 2016.
            </p>
          </div>
        </div>
      </div>
  );
};

export default Data3;
